interface PanelLoaderProps {
  message?: string;
}

/*
 * DER PLATZHALTER, WAEHREND EIN PANEL NACHGELADEN WIRD — und die Kennung, an der
 * eine Aufnahme ihn erkennt.
 *
 * `data-ai-id="panel-laedt"` ist hier kein Beiwerk: /api/capture wartet mit
 * `kacheln_fertig=<ms>` darauf, dass KEIN solcher Platzhalter mehr im Baum steht,
 * und weist die Aufnahme sonst ab (409). Ohne die Kennung sieht eine Kachel, die
 * nur "Loading..." zeigt, auf dem Bild aus wie eine Kachel — und ein Foto, das wie
 * ein Beleg aussieht und keiner ist, war am 07.09. genau der Fehler (gestapelte
 * Buehne, zwei von vier Kacheln ungezeichnet, 204 KB und damit fuer die
 * Groessenschranke unauffaellig).
 *
 * Diese Fassung galt bis 07.09. nur fuer den Direktlink (/?panel=…), waehrend der
 * Arbeitsbereich eine eigene, wortgleiche Kopie in LayoutManager hatte. Zwei
 * Fassungen desselben Platzhalters heisst: die Kennung sitzt frueher oder spaeter
 * nur an einer, und die Aufnahme uebersieht die andere. Deshalb gibt es sie jetzt
 * nur noch hier; LayoutManager reicht seinen Text als `message` herein.
 */
export default function PanelLoader({ message = 'Loading...' }: PanelLoaderProps) {
  return (
    <div data-ai-id="panel-laedt" style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--tn-text-muted)', fontSize: 11 }}>
      {message}
    </div>
  );
}
